import clsx from "clsx";

import Alert from "ui-components/Alert";

import { UploadStatus } from "./types";

interface Props {
  f: File;
  uploadStatus: UploadStatus;
}

const FileStatus = ({ f, uploadStatus }: Props) => {
  const { errorMessage = "Unable to upload file" } = uploadStatus;
  return (
    <div className="my-1">
      <p className="font-bold">{f.name}</p>
      {uploadStatus["error"] ? (
        <Alert variant="error">
          {typeof errorMessage === "string" ? (
            errorMessage
          ) : Object.values(errorMessage).length === 1 ? (
            Object.values(errorMessage)[0]
          ) : (
            <>
              {Object.values(errorMessage).map((err) => (
                <p key={err}>{err}</p>
              ))}
            </>
          )}
        </Alert>
      ) : uploadStatus["completed"] ? (
        <Alert variant="success">Successfully Processed File.</Alert>
      ) : (
        <Alert variant="info">
          {uploadStatus["status"] || "Processing In-Progress"}
        </Alert>
      )}
      <div className="relative pt-1">
        <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-gray-200">
          <div
            style={{
              width: `${uploadStatus["progress"] || 0}%`,
            }}
            className={clsx(
              "shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center",
              uploadStatus["error"] ? "bg-primary-light" : "bg-success-light"
            )}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default FileStatus;
